module.exports = __webpack_public_path__ + "static/media/pic01.caadfd1b.svg";